import { IEventV2 } from '../../../../../../data/entities/event';

const acceptedChannelsForAutomation = [
	'tripadvisor.com',
	'booking.com',
	'airbnb.com',
	'expedia.com',
	'homeaway.co.uk',
	'holidu.co.uk',
	'hometogo.com'];

export const failureStateEventMappings = {
	DISCREPANCY_THRESHOLD_EXCEEDED: {
		override: 'DISCREPANCY_APPROVED',
		display: 'There is a discrepancy with this booking',
		overrideDisplay: 'Approve discrepancy'
	},
	POTENTIALLY_FRAUDULENT: {
		override: 'CONFIRMED_NON_FRAUDULENT',
		display: 'This booking has been flagged as being potentially fraudulent',
		overrideDisplay: 'Confirm booking is not fraudulent'
	},
	BOOKING_BREAKDOWN_FAILED: {
		display: 'Failed to generate breakdown for booking',
	},
	ZERO_VALUE_BOOKING: {
		display: 'The TBV for this booking is zero'
	},
	CANCELLATION_WINDOW_CLOSED: {
		override: 'OVERRIDE_CANCELLATION_WINDOW_CLOSED',
		display: 'This booking is outside of the free cancellation window',
		overrideDisplay: 'Booking is suitable to be processed outside of the free cancellation window'
	},
	PRELOAD_FAILED: {
		override: 'OVERRIDE_PRELOAD_FAILED',
		display: 'Failed to store CC details for booking',
		overrideDisplay: 'Guest CC details have been successfully stored/charged'
	},
	INVALID_GUEST_DETAILS: {
		display: 'We don\'t have valid details for the guest (usually LastMinute.com)',
	},
	FAILED_TO_RETRIEVE_GUEST_COMMS: {
		override: 'GUEST_COMMS_MANUALLY_ADDED',
		display: 'Failed to automatically retrieve guest notes from channel, please attach them to the booking manually.',
		overrideDisplay: 'Guest notes have been attached'
	},
	INSUFFICIENT_PAYMENT_DETAILS: {
		display: 'This booking has insufficient guest payment details'
	}
};

export const displayAutomationProcesses = (event: IEventV2) => {
	const source = event?.source;
	return acceptedChannelsForAutomation.some((channel) => source?.includes(channel));

};
